import React from "react";
import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import Checkbox from "../../../../core/CheckBox";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
import Svg from '../../../../component/common/Svg'

import { Link, useNavigate} from "react-router-dom";
import axios from "axios";
import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
import { PublicClientApplication } from '@azure/msal-browser';
// import { LocalStorage } from "node-localstorage";

import Google from "../../../../assets/images/Google.svg";
import Title from "../Title";
import Header from "../../../../component/common/landing-page/widgets/Header";
import { useDispatch } from "react-redux";
import { checkLogin } from "../../../../store/actions/authAction";

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from "react-redux";
import CookieBanner from "../../../../component/common/CookieBanner";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Login = () => {
  const navigate = useNavigate()

  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const [flag, setFlag] = useState(0);
  const dispatch = useDispatch()
  const [msalReady, setMsalReady] = useState(false);
  const [ssoEnabled, setSsoEnabled] = useState(false);

  const { isLoading,  status, message } = useSelector((state) => state.authData)


  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
    genratePublicToken();
    fetchSsoStatus();
  }, []);

  function fetchSsoStatus() {
    axios.get(process.env.REACT_APP_NODE_API_URL + "/auth/sso-status")
      .then((response) => {
        if (response?.data?.data?.sso_enabled) {
          setSsoEnabled(true);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch SSO status", err);
      });
  }

  function viewPassword(e) {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  }


  function genratePublicToken() {
    axios.get(process.env.REACT_APP_NODE_API_URL + "/auth/getPubToken", {
    }).then((response) => {
      // console.log(response.status)
      if (response.status == 200) {
        console.log("Public Token genrated..");
        //alert("public token Genrated successfully!");
      } else {
        // alert("Try Again, Error");
      }
    }).catch((error) => {
      console.log('GET PUBLIC TOKEN ERROR', error)
    });
  }

  // Microsoft SSO (OIDC) -> Exchange ID token for local token_id
  const msalInstanceRef = React.useRef(null);

  const isUserCancelledError = (err) => {
    const code = err?.errorCode || '';
    return code === 'user_cancelled' || code === 'access_denied' || code === 'consent_required';
  };

  useEffect(() => {
    // Initialize MSAL instance once
    if (!msalInstanceRef.current && process.env.REACT_APP_AZURE_AD_CLIENT_ID && process.env.REACT_APP_AZURE_AD_TENANT_ID) {
      const instance = new PublicClientApplication({
        auth: {
          clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
          authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID}`,
          redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECT_URI || window.location.origin,
        },
        cache: { cacheLocation: 'sessionStorage', storeAuthStateInCookie: false },
      });
      msalInstanceRef.current = instance;
      (async () => {
        try {
          await instance.initialize();
          setMsalReady(true);
        } catch (err) {
          console.error('MSAL init error', err);
          toast.error('Microsoft SSO init error');
        }
      })();
    }
  }, []);

  const handleMicrosoftLogin = async () => {
    try {
      if (!msalInstanceRef.current) {
        toast.error('Microsoft SSO is not configured');
        return;
      }
      if (!msalReady) {
        try {
          await msalInstanceRef.current.initialize();
          setMsalReady(true);
        } catch (err) {
          console.error('MSAL init error', err);
          toast.error('Microsoft SSO init error');
          return;
        }
      }

      // Clear any stuck "interaction_in_progress" state from a previous cancelled attempt
      const activeInteraction = sessionStorage.getItem(`msal.${process.env.REACT_APP_AZURE_AD_CLIENT_ID}.interaction.status`);
      if (activeInteraction) {
        sessionStorage.removeItem(`msal.${process.env.REACT_APP_AZURE_AD_CLIENT_ID}.interaction.status`);
      }

      const loginResp = await msalInstanceRef.current.loginPopup({ scopes: ['openid', 'profile', 'email'], prompt: 'select_account' });
      // Set active account for subsequent silent token requests
      if (loginResp && loginResp.account) {
        msalInstanceRef.current.setActiveAccount(loginResp.account);
      }

      // Acquire an access token for our API scope (as per Microsoft guidance)
      const apiScope = process.env.REACT_APP_AZURE_AD_API_SCOPE;
      if (!apiScope) {
        toast.error('API scope not configured');
        return;
      }

      let accessToken = null;
      try {
        const tokenResp = await msalInstanceRef.current.acquireTokenSilent({
          scopes: [apiScope],
          account: loginResp?.account || msalInstanceRef.current.getActiveAccount()
        });
        accessToken = tokenResp && tokenResp.accessToken;
      } catch (silentErr) {
        console.warn('acquireTokenSilent failed, trying popup', silentErr);
        try {
          const tokenRespPopup = await msalInstanceRef.current.acquireTokenPopup({ scopes: [apiScope], prompt: 'consent' });
          accessToken = tokenRespPopup && tokenRespPopup.accessToken;
        } catch (popupErr) {
          console.error('acquireTokenPopup failed', popupErr);
          try {
            await msalInstanceRef.current.acquireTokenRedirect({ scopes: [apiScope], prompt: 'consent' });
            return;
          } catch (redirErr) {
            console.error('acquireTokenRedirect failed', redirErr);
            toast.error('Failed to acquire access token');
            return;
          }
        }
      }
      if (!accessToken) {
        toast.error('Failed to acquire access token');
        return;
      }
      const exchangeUrl = `${process.env.REACT_APP_NODE_API_URL}/auth/azure/exchange`;
      const exchangeResp = await axios.post(exchangeUrl, {}, { headers: { Authorization: `Bearer ${accessToken}` } });
      console.log('azure/exchange response', exchangeResp?.data);
      if (exchangeResp?.data?.statusCode === 200) {
        localStorage.setItem('token_id', exchangeResp?.data?.data?.token_id);
        navigate('/admin/survey/list');
      } else if (exchangeResp?.data?.statusCode === 202) {
        navigate('/team-verification/');
      } else {
        toast.error(exchangeResp?.data?.msg || 'Microsoft SSO failed');
      }
    } catch (e) {
      if (isUserCancelledError(e)) {
        console.log('SSO login was cancelled by user');
        return;
      }
      if (e?.errorCode === 'interaction_in_progress') {
        console.warn('Clearing stuck MSAL interaction state');
        sessionStorage.clear();
        toast.info('Please try again');
        return;
      }
      console.error('Microsoft SSO error', e);
      toast.error('Microsoft SSO error');
    }
  };

  const handleCount = e => {
    setCount(String(e.target.value).length);
  };

  const responseGoogleSuccess = (credentialResponse) => {
    const signUpData = (parseJwt(credentialResponse.credential));
    //console.log(signUpData);

    if (signUpData.email_verified === true) {

      axios.post(process.env.REACT_APP_NODE_API_URL + "/users/getUserDetails", {
        email: signUpData.email,
      }).then((response) => {
        console.log(response.data)
        //res.redirect('/');
        if (response.data.response == 200) {
          // alert("Login Sccessful!");
          toast.success('Login SccessFull !');
          window.location = '/admin/survey/list';
        } else {
          // alert("User not present, please Register");
          toast.error("User not present, please Register")
        }
      });
      // alert("successfully logined!");
    }
  }

  function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  const responseGoogleFail = (credentialResponse) => {
    alert("Google Login Failed, Try Again");
  }

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [items, setItems] = useState([]);


  //posting Login Details
  const submitLogin = async () => {
    // let options = {
    //   method: 'POST',
    //   url: process.env.REACT_APP_NODE_API_URL + "/users/checkLogin",
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json;charset=UTF-8'
    //   },
    //   data: {
    //     email: email,
    //     password: password,
    //   }
    // }
    // axios(options).then((response) => {
    //   console.log(response.data.response)
    //res.redirect('/');
    // if (response.data.response == 200) {
    //   alert("Login Sccessful!");
    //   localStorage.setItem('token_id', response.data.token_id);
    //   window.location = '/admin/survey/list';

    // } else if (response.data.response == 202) {
    //   alert("This Email Id is already present, continue to verify");
    //   // window.location = '/EmailVerification/?email=' + email;
    //   axios.get(process.env.REACT_APP_NODE_API_URL + "/users/resendRegistrationOtp?email=" + email, {
    //     // email: email,
    //   }).then((response) => {
    //     if (response.status == 200) {
    //       window.location = '/EmailVerification/?email=' + email;
    //     } else {
    //       alert("Unable to send OTP up..");
    //     }
    //   });

    // } else {
    //   alert("Unable to login, Invalid Credentials");
    // }
    // }).catch((error) => {
    //   console.log('LOGIN ERROR', error)
    // });
  };


  //==> FORM SCHEMA AND VALIDATION <==

  //Yup - Schema
  // const formSchema = Yup.object().shape({
  //   email: Yup.string().trim().email('This is not a valid email').required('Email required'),
  //   password: Yup.string().trim().required('Password required'),
  // })

  const formSchema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .matches(/^\S+$/, 'Email cannot contain spaces')
      .email('This is not a valid email')
      .required('Email required'),
    password: Yup.string()
      .trim()
      .matches(/^\S.*\S$/, 'Password cannot contain leading or trailing spaces')
      .required('Password required'),
  });
  //Formik - Validation
  const initialValues = {
    email: '',
    password: '',
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: formSchema,
    onSubmit: (values) => {
      const payload = {
        email: values.email,
        password: values.password,
      }

      dispatch(checkLogin(payload, loginCallBack, mfaCallBack, passwordExpiredCallBack))
      let f = flag + 1;
      setFlag(f);
    }
  })

  const { values, handleChange, handleBlur, touched, errors, handleSubmit, setFieldValue } = formik

  const loginCallBack = (token) => {
    navigate(`/admin/survey/list`, {state: {token}})
  }

  const mfaCallBack = (data) => {
    navigate(`/admin/mfa-verification?email=${data.email}&user_id=${data.user_id}`)
  }

  const passwordExpiredCallBack = (data) => {
    toast.error("Your password has expired. Please set a new password.");
    navigate(`/admin/password-expired?email=${data.email}`)
  }

  useEffect(() => {
    if (status == 401) {
      toast.error(message);
      dispatch({ type: 'RESET_LOGIN' });
    }
    if (status == 400) {
      toast.error(message);
      dispatch({ type: 'RESET_LOGIN' });
    }
    if (status == 423) {
      toast.error(message);
      dispatch({ type: 'RESET_LOGIN' });
    }
    if (status == 403) {
      toast.error(message);
      dispatch({ type: 'RESET_LOGIN' });
    }
  }, [status]);

  return (
    <>
      <CookieBanner />
      <div className='d-flex flex-column site-main-wrapper login-page'>
        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-outer-wrapper">
              <div className="logo-wrap text-center">
                <Link to="/#0t" className='home-logo'>
                  <Svg name="logo" />
                </Link>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-wrapper mb__20">
                  <div className="form-heading text-center">
                    <h3>Log in or sign up in seconds</h3>
                    <p>Use your work email to log in or get started</p>
                  </div>
                  <div className="field-wrapper">
                    <div className={`mb__20 position-relative ${touched.email ? (errors.email ? 'error' : 'success') : ''}`}> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                      < Input
                        ref={inputRef}
                        type='text'
                        view='outlined'
                        dense={false}
                        color='default'
                        label=''
                        placeholder='Enter your work email address...'
                        clearButton={true}
                        success={false}
                        error={false}
                        fill={true}
                        errorHelperText={null}
                        className={"formsinput"}
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onClear={() => setFieldValue(email, '')}
                      />
                      {touched.email && errors.email && <div className="validation-msg"> {errors.email}</div>}
                    </div>
                    <div className={`mb-2 position-relative ${touched.password ? (errors.password ? 'error' : 'success') : ''}`}>{/* Add Class error to this div once error occurs and if its valid, add class success*/}
                      <Input
                        type={passwordType}
                        view="outlined"
                        color="default"
                        label=""
                        placeholder="Enter your password..."
                        fill
                        className={"formsinput"}
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.password && errors.password && <div className="validation-msg"> {errors.password}</div>}

                      <span className={"forgot-wrap " + passwordType} onClick={viewPassword}>
                        <i className="fa fa-eye " aria-hidden="true"></i>
                      </span>
                    </div>
                    <div className={"additional-info mb__20" + " " + style.additional_line}>
                      <Checkbox
                        type="dense"
                        color="default"
                        checked={isChecked}
                        label="Remember me"
                        onChange={() => setChecked(!isChecked)}
                        className={"formscheckbox"}
                      />
                      <Link to="/admin/forgot-password">
                        <Typography
                          type="caption"
                          colorStep={60}
                          tagName="div"
                        >
                          <b> Reset password</b>
                        </Typography>
                      </Link>
                    </div>
                  </div>
                  <div className="button-wrap">

                    <button
                      type="submit"
                      className="formsbutton btn-primary btn mb__20 w-100"
                      disable={!isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="white-spinner spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span className="visually-hidden">Loading...</span>
                        </>
                      ) : (
                        "Continue"
                      )}
                    </button>

                    {/* GOOGLE LOGIN */}
                    {/* <div className="google-btn">
                      <GoogleLogin
                        onSuccess={responseGoogleSuccess}
                        onFailure={responseGoogleFail}
                      />
                    </div> */}

                    {/* MICROSOFT LOGIN */}
                    {ssoEnabled && (
                      <button
                        type="button"
                        className="formsbutton btn-primary btn mb__20 w-100"
                        onClick={handleMicrosoftLogin}
                        style={{ marginTop: '8px' }}
                      >
                        Sign in with Microsoft
                      </button>
                    )}
                  </div>
                  {/* CREATE ACCOUNT */}
                  {/* <div className="form-text text-center">
                    <p>Don’t have an account? <Link to="/admin/signup">Create an account</Link></p>
                  </div> */}
                </div>
              </form>
              <div className="outer-form-text text-center">
                <p>By continuing, you agree to Survey Tool <Link to="/admin/terms" target="_blank" rel="noopener noreferrer">Terms of Use</Link> Read our <Link to="/admin/privacy-policies">Privacy Policy</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
